<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style='background-color: #d4b6d7;filter: drop-shadow(1px 1px 1px #6666664d);'>
    <div class="desktop-header">
        <div #header1 class="container green containerHeader">
            <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
                role="tooltip" id="tooltip164687" x-placement="right"
                style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
                <div class="arrow" style="top: 8px;"></div>
                <div class="tooltip-inner">Your Logo Here</div>
            </div>
            <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
                data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here"
                style="display: flex; align-items: center;">
                <img src="assets/images/logos-header/lr.svg" height="60" alt="logo" style="border-radius: 50px;">
            </a>
            <a *ngIf="this.companyParamsService.getWebSite()" href="https://www.latamretreats.com/" class="navbar-brand"
                target="_blank" style="display: flex; align-items: center;">
                <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
                <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
                <img src="assets/images/logos-header/lr.svg" height="60" alt="logo" style="border-radius: 50px;">
            </a>
            <div class="containerMenu navbar-collapse collapse" style="justify-content: center;">
                <ul class="navbar-nav menuContainer" style="width: 100%; padding: 12px 30px;">
                    <li class="nav-item menuItem"><a href="https://latamretreats.com/match-your-journey/"
                            target="_blank">Destinations</a>
                    </li>
                    <li class="nav-item menuItem"><a
                            href="https://latamretreats.com/match-your-journey/?myj_category=retreat"
                            target="_blank">Retreats</a>
                    </li>
                    <li class="nav-item menuItem"><a
                            href="https://latamretreats.com/match-your-journey/?myj_category=tour"
                            target="_blank">Experiences</a></li>
                    <li class="nav-item menuItem"><a href="https://agencies.galavail.com/latamretreats/search/"
                            target="_blank">Cruises</a>
                    </li>
                    <li class="nav-item menuItem"><a href="https://latamretreats.com/blog/" target="_blank">Blog</a>
                    </li>
                    <li class="nav-item menuItem"><a href="https://latamretreats.com/about-us/" target="_blank">About
                            us</a></li>
                </ul>
            </div>
            <div class="button-container">
                <a class="contact-us-button" href="https://latamretreats.com/contact/"
                    style="color: #000000;" target="_blank">Contact us</a>
                <div style="display: flex; flex-direction: row;" class="flags">
                    <a href="https://www.latamretreats.com/" style="padding: 5px;" target="_blank">
                        <img src="assets/images/gb.svg" height="18">
                    </a>
                    <a href="https://www.latamretreats.com/es" style="padding: 5px;" target="_blank">
                        <img src="assets/images/es.svg" height="18">
                    </a>
                </div>
                <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                    <app-heart-header></app-heart-header>
                </div>
            </div>
        </div>
    </div>
    <div class="responsiveHeader">
        <div class="container green containerHeader"
            style="display:flex;justify-content: space-between; flex-direction: row!important;align-items: center;">
            <span style="padding-left: 20px;"><img src="assets/images/logos-header/lr.svg" height="60"
                    style="border-radius: 50px;" /></span>
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()" style="padding-right: 1em;">
                <i class="fa fa-bars fa-3x" style="color:gray !important; padding: 20px;"></i>
            </a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://latamretreats.com/match-your-journey/"
                target="_blank">Destinations</a>
        </li>
        <li class="nav-item menuItem"><a href="https://latamretreats.com/match-your-journey/?myj_category=retreat"
                target="_blank">Retreats</a>
        </li>
        <li class="nav-item menuItem"><a href="https://latamretreats.com/match-your-journey/?myj_category=tour"
                target="_blank">Experiences</a></li>
        <li class="nav-item menuItem"><a href="https://agencies.galavail.com/latamretreats/search/"
                target="_blank">Cruises</a>
        </li>
        <li class="nav-item menuItem"><a href="https://latamretreats.com/blog/" target="_blank">Blog</a>
        </li>
        <li class="nav-item menuItem"><a href="https://latamretreats.com/about-us/" target="_blank">About
                us</a></li>
        <li class="nav-item menuItem">
            <div style="display: flex; flex-direction: row; border: 0px;" class="flags">
                <a href="https://www.latamretreats.com/" style="padding: 5px;" target="_blank">
                    <img src="assets/images/gb.svg" height="18">
                </a>
                <a href="https://www.latamretreats.com/es" style="padding: 5px;" target="_blank">
                    <img src="assets/images/es.svg" height="18">
                </a>
            </div>
        </li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>